import type { ReactNode } from "react";
import { NavLink, useMatch, useResolvedPath } from "react-router-dom";

/**
 * Fane i prosjektdetaljens fanelinje: en NavLink med tab-semantikk
 * (role=tab, aria-selected) så fanelinjen kan navigeres med piltaster
 * (VIB-2541). URL og tilbakeknapp virker som før.
 */
export function ProjectTabLink({
  to,
  end = false,
  className,
  children,
}: {
  to: string;
  end?: boolean;
  className: (props: { isActive: boolean }) => string;
  children: ReactNode;
}) {
  const resolved = useResolvedPath(to);
  const active = useMatch({ path: resolved.pathname, end }) !== null;
  return (
    <NavLink to={to} end={end} role="tab" aria-selected={active} className={className}>
      {children}
    </NavLink>
  );
}
